<template>
  <div v-if="propsComp.posts?.length" class="featured-posts-widget">
    <WidgetLayout :background-color="props.backgroundColor">
      <ClientOnly>
        <div class="featured-posts-widget-inner">
          <h2 v-if="getWidgetTextTranslation(props.heading).length" class="h4 w-full">
            {{ getWidgetTextTranslation(props.heading) }}
          </h2>
          <div class="featured-posts-grid">
            <NuxtLink
              v-for="(post, index) in propsComp.posts"
              :key="index"
              :to="getWidgetTextTranslation(post.slug)"
              :title="getWidgetTextTranslation(post.title)"
              class="featured-posts-item">
              <span
                v-if="getWidgetTranslatedMediaUrl(post.image).length"
                class="featured-post-image"
                :style="{
                  backgroundImage: `url(${getWidgetTranslatedMediaUrl(post.image)})`,
                }" />
              <h3 v-if="getWidgetTextTranslation(post.title).length" class="featured-post-heading">
                {{ getWidgetTextTranslation(post.title) }}
              </h3>
              <p v-if="getWidgetTextTranslation(post.excerpt).length" class="featured-post-excerpt">
                {{ getWidgetTextTranslation(post.excerpt) }}
              </p>
            </NuxtLink>
          </div>
        </div>
      </ClientOnly>
    </WidgetLayout>
  </div>
</template>

<script lang="ts" setup>
import WidgetLayout from '~/components/Widgets/WidgetLayout.vue'
import type { TranslatableString } from '~/types/widgets/widgetTypes'
import getWidgetTextTranslation from '../../utils/getWidgetTextTranslation'
import getWidgetTranslatedMediaUrl from '~/utils/getWidgetTranslatedMediaUrl'

const props = defineProps<{
  heading: TranslatableString
  posts: {
    slug: TranslatableString
    image: TranslatableString
    title: TranslatableString
    excerpt: TranslatableString
  }[]
  backgroundColor?: string
}>()

const propsComp = computed(() => {
  return {
    heading: props.heading,
    posts: props.posts?.filter((post) => {
      return (
        getWidgetTranslatedMediaUrl(post.image).length ||
        getWidgetTextTranslation(post.title).length ||
        getWidgetTextTranslation(post.excerpt).length
      )
    }),
    backgroundColor: props.backgroundColor,
  }
})
</script>

<style lang="postcss" scoped>
.featured-posts-widget {
  @apply py-4;

  :deep(.featured-posts-widget-inner) {
    @apply flex flex-col gap-4;

    .featured-posts-grid {
      @apply grid grid-cols-1 xl:grid-cols-3 gap-4 lg:gap-6 pt-2 lg:pt-4;

      .featured-posts-item {
        @apply flex flex-col p-3 lg:p-6 gap-3 lg:gap-4 bg-white dark:bg-dmGray1 border border-neutral6 dark:border-dmGray1 rounded-sm no-underline;

        .featured-post-image {
          @apply block w-full pb-[66.666667%] bg-no-repeat bg-center bg-contain rounded-[0.625rem];
        }

        .featured-post-heading {
          @apply text-[1rem] lg:text-[1.875rem] pt-1 lg:pt-2 leading-[1.2];
        }

        .featured-post-excerpt {
          @apply text-sm lg:text-base font-primary leading-[1.2] pb-1 lg:pb-0 mt-auto;
        }
      }
    }
  }
}
</style>
